export default __webpack_public_path__ + "static/media/Impenetrable Word of Valka.0ea90c0e.jpg";